// Placeholder Page - Full implementation in Phase 1
export default function SettingsPage() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-white mb-6">Settings</h1>
      <div className="card mb-6">
        <h2 className="text-lg font-semibold text-white mb-4">API Keys</h2>
        <p className="text-dark-400 mb-4">Configure your AI provider API keys to enable chat functionality.</p>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-dark-200 mb-2">Claude API Key</label>
            <input type="password" placeholder="sk-ant-..." className="input" />
          </div>
          <div>
            <label className="block text-sm font-medium text-dark-200 mb-2">Gemini API Key</label>
            <input type="password" placeholder="AIza..." className="input" />
          </div>
          <button className="btn-primary">Save API Keys</button>
        </div>
      </div>
    </div>
  )
}
